import { KPI } from './../api/models';
import { APIService } from './../api/api.service';
import { Injectable } from '@angular/core';
import * as R from 'ramda';
import { BehaviorSubject, Observable, pipe } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ObservableMap } from './initiatives.service';

@Injectable({
  providedIn: 'root'
})
export class PriceSheetService {

  constructor(
    private apiService: APIService,
  ) { }

  private priceSheetsByAssetType: ObservableMap<KPI.PriceSheet[]> = {};
  public getPriceSheetsByAssetType(assetTypeId: number): Observable<KPI.PriceSheet[]> {
    const key = this.getKey(arguments);
    this.priceSheetsByAssetType[key] = this.apiService.get_price_sheets_by_asset_type(assetTypeId).pipe(
      shareReplay(1)
    );
    return this.priceSheetsByAssetType[key];
  }

  private priceSheetCostItems: Observable<KPI.PriceSheetCostItem[]>;
  public get priceSheetCostItems$(): Observable<KPI.PriceSheetCostItem[]> {
    if (!this.priceSheetCostItems) {
      this.priceSheetCostItems = this.apiService.get_price_sheet_cost_items().pipe(
        pipe(shareReplay(1))
      )
    }
    return this.priceSheetCostItems;
  }

  private priceSheets: ObservableMap<KPI.PriceSheet> = {};
  public getPriceSheet(priceSheetId: number): Observable<KPI.PriceSheet> {
    const key = this.getKey(arguments);
    if (!this.priceSheets[key]) {
      this.priceSheets[key] = this.apiService.get_price_sheet(priceSheetId).pipe(
        shareReplay(1)
      );
    }
    return this.priceSheets[key];
  }

  public clearPriceSheetCache(_priceSheetId: number): void {
    const key = this.getKey(arguments);
    delete this.priceSheets[key];
  }

  public createPriceSheet(
    assetTypeId: number,
    quantityUnit: number,
    formValue: any,
    authorId: number,
    isDefault: boolean
  ): Observable<KPI.PriceSheet> {
    return this.apiService.create_price_sheet(
      assetTypeId,
      {
        label: formValue.label,
        average_price: formValue.average_price,
        min_price: formValue.min_price || null,
        max_price: formValue.max_price || null,
        is_default: isDefault,
        is_benchmark: false,
        is_customer: true,
        quantity: formValue.quantity,
        quantity_unit: quantityUnit,
        author: authorId,
        budget_scope: formValue.budget_scope,
        year: new Date().getFullYear(),
        comments: formValue.comments,
        model: null,
        investment_type: formValue.investment_type || null,
      }
    );
  }

  public updatePriceSheet(
    priceSheetId: number,
    formValue: any,
    authorId: number,
    isDefault:boolean
  ): Observable<KPI.PriceSheet> {
    const payload: any = {
      label: formValue.label,
      quantity: formValue.quantity,
      last_modification_author: authorId,
      budget_scope: formValue.budget_scope,
      average_price: formValue.average_price,
      min_price: formValue.min_price || null,
      max_price: formValue.max_price || null,
      is_default: isDefault,
      investment_type: formValue.investment_type || null,
    };

    if (formValue.comments !== null && formValue.comments !== undefined) {
      payload.comments = formValue.comments;
    }

    return this.apiService.update_price_sheet(priceSheetId, payload);
  }


  public _pricesheetsHaveChanged$ = new BehaviorSubject<void>(undefined);
  public pricesheetsHaveChanged() {
    this._pricesheetsHaveChanged$.next();
  }

  private getKey(args: IArguments): string {
    return JSON.stringify(R.pickBy(R.complement(R.isNil), args));
  }

  public deletePriceSheet(pricesheetId: number) {
    return this.apiService.delete_price_sheet(pricesheetId);
  }

  public _defaultPSHasChanged$ = new BehaviorSubject<void>(undefined);
  public defaultPSHasChanged() {
    this._defaultPSHasChanged$.next();
  }

  public changeDefaultPriceSheet(newDefaultPsId: number) {
    const options = {
      is_default: true,
    }
    return this.apiService.update_price_sheet(newDefaultPsId, options);
  }

}
